const pageData = {
    specialities: [
        
    ]
}
$(document).ready(() => {
    $('#searchLang').val(Lang.getCurrentLang())
    RequestAPI.get({
        action: 'community/getMainExploreCommunityPage',
        onSuccess: (response) => {
            pageData.specialities = response.specialities;
            
            pageData.specialities = pageData.specialities.map((speciality) => {
                speciality.categories = speciality.categories.map((category) => {
                    return category
                })
                return speciality
            });

            (new PageRender()).render()
        }
    })

    addEventListeners()

    function addEventListeners(){
        $('#querySearch').on('keydown', (e) => {
            if (e.key == 'Enter'){
                const q = $('#querySearch').val()

                const url = TURL.new(EnvironmentVariables.get('App.RootURL') + '/community/search')
                url.addParameter('q', q)
                url.load()
            }
        })
        $('#querySearch').parent().children('i').on('click', () => {
            const q = $('#querySearch').val()

            const url = TURL.new(EnvironmentVariables.get('App.RootURL') + '/community/search')
            url.addParameter('q', q)
            url.load()
        })
    }
})

class PageRender{
    render(){
        this._renderCategoriesList()
        this._renderFilesTypesList()
        this.renderAndLoadURL()
        $('.loading').remove()
    }
    _renderCategoriesList(){
        const specialities = pageData.specialities.map((speciality) => {
            const ctrl = $.renderHTML(`
                <li>
                    <a>
                        <img src="${Reflection.getBucket()}/www/public/assets/icons/specializations/${speciality.id}.svg">
                        <span>${speciality.name}</span>
                    </a>
                </li>
            `)

            ctrl.on('click', () => {
                this.openSpeciality(speciality)
                Navigation.openPseudoPage('/community/explore/' + StringTools.convertIdentificatorToSlug(speciality.id))
            })

            return ctrl
        })
        
        $('#listSpecialities').append(specialities)
    }
    _renderFilesTypesList(){
        const select = $.renderHTML(`
            <select></select>
        `)
        let listCTRLs = []

        let filesTypes = Application.getFileSystem().getFilesTypes()
        filesTypes.All = {
            color: '#205caa',
            icon: 'fa-ball-pile',
            namePlural: Lang.load({PT: 'Tudo', EN: 'All', ES: 'Todo'})
        }
        DictionaryTools.forEach(filesTypes, (type, data) => {
            if (type == 'PDF'){
                data.icon = 'fa-file-pdf'
            }

            select.append(`
                <option name="${data.namePlural}" icon="${data.icon}" color="${data.color}" value="${type}"></option>
            `)
            const ctrl = $.renderHTML(`
                <li>
                    <i class="fad ${data.icon}"></i>
                    <span>${data.namePlural}</span>
                </li>
            `)
            ctrl.find('i').css('color', data.color)
            
            ctrl.on('click', () => {
                select.focus()
                select.val(type)
                select.trigger('change')
                select.blur()
                select.focus()
            })
            listCTRLs.push(ctrl)
        })


        select.on('change', () => {
            const val = select.val()

            const option = select.find(`[value="${val}"]`)
            $('.typesExplorer > div > span').text(option.getAttr('name'))
            $('.typesExplorer > div > div > i').removeClass()
            $('.typesExplorer > div > div > i').addClass('fad ' + option.getAttr('icon'))
            $('.typesExplorer > div > div > i').css('color', option.getAttr('color'))

            $('.explorerContainer > section > header > div > h1').trigger('click')
        })
        $('#searchLang').on('change', () => {
            $('.explorerContainer > section > header > div > h1').trigger('click')
        })
        
        $('.typesExplorer > div').on('click', () => {
            if ($('.typesExplorer').hasAttr('show')){
                $('.typesExplorer').removeAttr('show')
            }else{
                $('.typesExplorer').focus()
                $('.typesExplorer').setAttr('show')
            }
            

        })
        $('.typesExplorer').append(select)
        
        select.get(0).addEventListener('blur', function(){
            $('.typesExplorer').removeAttr('show')
        })
        $('#listFilesTypes').append(listCTRLs)
        select.val('All')
        select.trigger('change')
    }
    __renderFileItem(file){
        const fileHTML = `
            <div class="fileItem" file-id="${file.id}">
                <header>
                    <img src="${URLMount.getAPI('community/getCommunityFileThumbnail', {
                        shareID: file.id
                    })}">
                </header>
                <section>
                    <a href="c/${file.permalink}"><h1>${file.name}</h1></a>
                    <div>
                        <a href="community/categories/${file.categoryID}"><span style="background-color: ${tools.getSpecialityByCategoryID(file.categoryID).color}">${tools.getSpecialityByCategoryID(file.categoryID).name}</span></a>
                        <div>
                            <span stars><i class="fas fa-star"></i> ${file.stats.stars}</span>
                            <span views><i class="fas fa-eye"></i> ${file.stats.views}</span>
                        </div>
                        <div>
                            <img src="${URLMount.getAPI('account/getUserAvatarByUsername', {
                                username: file.owner,
                                h: 20,
                                w: 20
                            })}">
                            <span>${file.owner}</span>
                        </div>
                    </div>
                </section>
                
            </div>
        `
        return $.renderHTML(fileHTML)
    }
    
    showSpeciality(speciality){
        const $this = this
        $('.explorerContainer > section > header > div > h1').text(speciality.name)
        $('.explorerContainer > section > header > div > h1').css('color', speciality.color)

        $('.explorerContainer > section > header > div > span').text(Lang.load({PT: 'Carregando...', EN: 'Loading...', ES: 'Cargando...'}))
        $('.explorerContainer > section > header > img').get(0).src = `/www/public/assets/icons/specializations/${speciality.id}.svg`

        $('.explorerContainer > section > header > div > h1').off()
        $('.explorerContainer > section > header > div > h1').on('click', () => {
            renderList()
        })

        $('.explorerContainer > section > header > button').removeAttr('appear')
        $('.explorerContainer > section > header > button').setAttr('disappear')

        $('#listCategories').find('*').remove()
        $('#explorerInSpeciality').display('none')
        $('#explorerInCategory').display('flex')

        $('#listItemsInCategory').find('*').remove()
        $('#explorerInCategory').append(`
            <section class="progressbarHolder">
                <div indeterminateProgressbar>
                    <div slider>
                        <div line></div>
                        <div sublineInc></div>
                        <div sublineDec></div>
                    </div>
                </div>
                <span>${Lang.load({PT: 'Carregando...', EN: 'Loading...', ES: 'Cargando...'})}</span>
            </section>
        `)

        if (speciality.files != undefined){
            renderList()
            $('#explorerInCategory').find('.progressbarHolder').remove()
        }

        RequestAPI.get({
            action: 'community/getItemsInSpecialityCommunityPage',
            parameters: {
                specialityID: speciality.id
            },
            onSuccess: (response) => {
                speciality.files = []
                response.forEach((file) => {
                    speciality.files.push(file)
                })
                
                renderList()
            },
            onError: () => {

            },
            onFinish: () => {
                $('#explorerInCategory').find('.progressbarHolder').remove()
            }
        })

        function renderList(){

            $('#listItemsInCategory').find('*').remove()
            const currentFileTypeRestriction = $('.typesExplorer > select').val()
            const currentFileLangRestriction = $('#searchLang').val();

            let filesToRender = []
            if (currentFileTypeRestriction == 'All'){
                filesToRender = speciality.files.map((file) => {
                    return file
                })
            }else{
                filesToRender = speciality.files.selectObjectsWhere('type', currentFileTypeRestriction).map((file) => {
                    return file
                })
            }
            
            if (currentFileLangRestriction != '*'){
                filesToRender = filesToRender.selectObjectsWhere('lang', currentFileLangRestriction).map((file) => {
                    return file
                })
            }

            $('.explorerContainer > section > header > div > span').text(filesToRender.length + ' items')

            const list = filesToRender.map((file) => {
                const ctrl = $.renderHTML(`
                    <li>
                        <img alt="${file.name}" loading="lazy" src="${URLMount.getAPI('community/getCommunityFileThumbnail', {
                            shareID: file.id
                        })}">
                        <div>
                            <a href="/c/${file.permalink}"><h1>${file.name}</h1></a>
                            <div>
                                <a><span>${file.type}</span></a>
                                <div stats>
                                    <span stars><i class="fas fa-star"></i> ${file.stats.stars}</span>
                                    <span views><i class="fas fa-eye"></i> ${file.stats.views}</span>
                                </div>
                                <div user>
                                    <img loading="lazy" alt="${file.owner}" src="${URLMount.getAPI('account/getUserAvatarByUsername', {
                                        username: file.owner,
                                        h: 20,
                                        w: 20
                                    })}">
                                    <span>${file.owner}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                `)

                ctrl.find('a > span').css('background-color', Application.getFileSystem().getFilesTypes()[file.type].color)
                return ctrl
            })
            
            $('#listItemsInCategory').append(list)

            if (list.length == 0){
                const c = $.renderHTML(`
                    <article class="emptyTopic">
                        <i class="fad fa-expand"></i>
                        <h1>${Lang.load({PT: 'Esse tópico está vazio', EN: 'This topic is empty', ES: 'Este tópico está vacío'})}</h1>
                    </article>
                `)
                $('#listItemsInCategory').append(c)
            }
        }

    }
    openSpeciality(speciality){
        this.showSpeciality(speciality)
        return;
        const $this = this
        $('.explorerContainer > section > header > div > h1').text(speciality.name)
        $('.explorerContainer > section > header > div > h1').css('color', speciality.color)

        $('.explorerContainer > section > header > div > span').text(speciality.categories.length + ' items')
        $('.explorerContainer > section > header > img').get(0).src = `/www/public/assets/icons/specializations/${speciality.id}.svg`


        $('.explorerContainer > section > header > button').removeAttr('appear')
        $('.explorerContainer > section > header > button').setAttr('disappear')
        $('.explorerContainer > section > header > div > h1').off()

        $('#listCategories').find('*').remove()


        const categories = speciality.categories.map((category) => {
            const ctrl = $.renderHTML(`
                <li>
                    <a>
                        <i class=""></i>
                        <span>${category.name}</span>
                    </a>
                </li>
            `)

            if (category.icon){
                ctrl.find('i').addClass(category.icon)
            }else{
                ctrl.find('i').addClass('fad fa-album-collection')
            }
            ctrl.find('i').css('color', speciality.color)

            ctrl.on('click', () => {
                $this.openCategory(category, speciality)
                Navigation.openPseudoPage('/community/explore/' + StringTools.convertIdentificatorToSlug(speciality.id) + '/' + StringTools.convertIdentificatorToSlug(category.id))
            })

            return ctrl
        })
        
        $('#listCategories').append(categories)


        if (categories.length == 0){
            const c = $.renderHTML(`
                <article class="emptyTopic">
                    <i class="fad fa-expand"></i>
                    <h1>${Lang.load({PT: 'Esse tópico está vazio', EN: 'This topic is empty', ES: 'Este tópico está vacío'})}</h1>
                </article>
            `)
            $('#listCategories').append(c)
        }

        $('#explorerInSpeciality').display('flex')
        $('#explorerInCategory').display('none')
    }

    openCategory(){
        $('#explorerInCategory').display('flex')
        $('#explorerInSpeciality').display('none')
        

        $('.explorerContainer > section > header > button').removeAttr('disappear')
        $('.explorerContainer > section > header > button').setAttr('appear')


        $('.explorerContainer > section > header > div > h1').text(category.name)
        $('.explorerContainer > section > header > div > span').text(speciality.name)

        $('.explorerContainer > section > header > button').off()
        $('.explorerContainer > section > header > button').on('click', () => {
            this.openSpeciality(speciality)
        })

        $('.explorerContainer > section > header > div > h1').off()
        $('.explorerContainer > section > header > div > h1').on('click', () => {
            renderList()
        })

        $('#explorerInCategory').append(`
            <section class="progressbarHolder">
                <div indeterminateProgressbar>
                    <div slider>
                        <div line></div>
                        <div sublineInc></div>
                        <div sublineDec></div>
                    </div>
                </div>
                <span>${Lang.load({PT: 'Carregando...', EN: 'Loading...', ES: 'Cargando...'})}</span>
            </section>
            
        `)

        if (category.files != undefined){
            renderList()
            $('#explorerInCategory').find('.progressbarHolder').remove()

        }else{
            RequestAPI.get({
                action: 'community/getItemsInSpecialityCommunityPage',
                parameters: {
                    specialityID: specialityID
                },
                onSuccess: (response) => {
                    category.files = []
                    response.forEach((file) => {
                        category.files.push(file)
                    })
                    
                    renderList()
                },
                onError: () => {
    
                },
                onFinish: () => {
                    $('#explorerInCategory').find('.progressbarHolder').remove()
                }
            })
        }
        


        function renderList(){
            $('#listItemsInCategory').find('*').remove()
            const currentFileTypeRestriction = $('.typesExplorer > select').val()


            let filesToRender = []
            if (currentFileTypeRestriction == 'All'){
                filesToRender = category.files.map((file) => {
                    return file
                })
            }else{
                filesToRender = category.files.selectObjectsWhere('type', currentFileTypeRestriction).map((file) => {
                    return file
                })
            }



            const list = filesToRender.map((file) => {
                const ctrl = $.renderHTML(`
                    <li>
                        <img alt="${file.name}" loading="lazy" src="${URLMount.getAPI('community/getCommunityFileThumbnail', {
                            shareID: file.id
                        })}">
                        <div>
                            <a href="/c/${file.permalink}"><h1>${file.name}</h1></a>
                            <div>
                                <a><span>${file.type}</span></a>
                                <div stats>
                                    <span stars><i class="fas fa-star"></i> ${file.stats.stars}</span>
                                    <span views><i class="fas fa-eye"></i> ${file.stats.views}</span>
                                </div>
                                <div user>
                                    <img loading="lazy" alt="${file.owner}" src="${URLMount.getAPI('account/getUserAvatarByUsername', {
                                        username: file.owner,
                                        h: 20,
                                        w: 20
                                    })}">
                                    <span>${file.owner}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                `)

                ctrl.find('a > span').css('background-color', Application.getFileSystem().getFilesTypes()[file.type].color)
                return ctrl
            })
            
            $('#listItemsInCategory').append(list)

            if (list.length == 0){
                const c = $.renderHTML(`
                    <article class="emptyTopic">
                        <i class="fad fa-expand"></i>
                        <h1>${Lang.load({PT: 'Esse tópico está vazio', EN: 'This topic is empty', ES: 'Este tópico está vacío'})}</h1>
                    </article>
                `)
                $('#listItemsInCategory').append(c)
            }
        }
    }

    renderAndLoadURL(){
        const currentURL = TURL.new()
        const dirData = {
            fileType: null,
            specialityID: null,
            categoryID: null
        }
        const filesTypes = DictionaryTools.map(Application.getFileSystem().getFilesTypes(), (fileType, value) => {
            return fileType.toLowerCase()
        })

        if (currentURL.getDirectories().length == 3){
            const specialityOrFileType = currentURL.getDirectory('last')
            if (filesTypes.includes(specialityOrFileType)){
                //t
                dirData.fileType = specialityOrFileType
            }else{
                //s
                dirData.specialityID = specialityOrFileType
            }
        }else if (currentURL.getDirectories().length == 4){
            const specialityOrFileType = currentURL.getDirectory(2)
            if (filesTypes.includes(specialityOrFileType)){
                //t,s
                dirData.fileType = specialityOrFileType
                dirData.specialityID = currentURL.getDirectory(3)
            }else{
                //s,c
                dirData.specialityID = specialityOrFileType
                dirData.categoryID = currentURL.getDirectory(3)
            }

        }else if (currentURL.getDirectories().length == 5){
            //t,s,c
            dirData.fileType = currentURL.getDirectory(2)
            dirData.specialityID = currentURL.getDirectory(3)
            dirData.categoryID = currentURL.getDirectory(4)
        }

        if (dirData.specialityID == null && dirData.categoryID == null){
            dirData.specialityID = StringTools.convertIdentificatorToSlug(pageData.specialities[0].id)
        }

        if (dirData.fileType != null){
            $('.typesExplorer > select').val(dirData.fileType.toUpperCaseFirstLetter())
            $('.typesExplorer > select').trigger('change')
        }
        if (dirData.specialityID != null){
            const specialityExists = pageData.specialities.verifyIfObjectExists('id', StringTools.convertSlugToIdentificator(dirData.specialityID))

            if (specialityExists == false){
                dirData.specialityID = StringTools.convertIdentificatorToSlug(pageData.specialities[0].id)
            }
            const speciality = pageData.specialities.selectObjectWhere('id', StringTools.convertSlugToIdentificator(dirData.specialityID))

            if (dirData.categoryID != null && specialityExists){
                const categoryExists = speciality.categories.verifyIfObjectExists('id', StringTools.convertSlugToIdentificator(dirData.categoryID))
                
                
                if (categoryExists){
                    this.openSpeciality(speciality)
                    this.openCategory(speciality.categories.selectObjectWhere('id', StringTools.convertSlugToIdentificator(dirData.categoryID)), speciality);
                }else{
                    this.openSpeciality(speciality)

                }
            }else if (dirData.categoryID == null && specialityExists){
                this.openSpeciality(speciality)
            }
        }

        this._loadPageBackAndForwardEvents()
    }
    _loadPageBackAndForwardEvents(){
        const $this = this;
        window.onpopstate = function(event) {
            $this.renderAndLoadURL()
        }
    }
}